import React, { useEffect, useRef } from "react";

const VisualRepresentation = ({ code, theme }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    // When new visualization code is received, send it to the iframe
    if (iframeRef.current) {
      // A short delay ensures the iframe has loaded and is ready to receive messages
      setTimeout(() => {
        iframeRef.current.contentWindow.postMessage({ code, theme }, "*");
      }, 500); // Adjust delay if needed
    }
  }, [code, theme]);

  return (
    <div className="w-full h-full">
      <iframe
        ref={iframeRef}
        src="/p5-runner.html"
        title="p5.js Sketch Runner"
        className="w-full h-full border-0"
        sandbox="allow-scripts"
        // Use the code as a key to force the iframe to re-render when the code changes
        key={code}
      />
    </div>
  );
};

export default VisualRepresentation;
